module.exports = __webpack_public_path__ + "img/indonesia-independence-day-2018.3906a649.png";